import { env } from "@/env";
import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";

import { RealmRoles } from "@workspace/schemas/zod";
import { Badge } from "@workspace/ui/components/badge";
import { Button } from "@workspace/ui/components/button";
import { Separator } from "@workspace/ui/components/separator";

import { SentryBackendTests } from "./-components/SentryBackendTests";
import { SentryFrontendTests } from "./-components/SentryFrontendTests";

export const Route = createFileRoute("/_standard/dev/")({
  beforeLoad: ({ context }) => {
    if (!context.auth?.hasRealmRole(RealmRoles.EPORT_ADMIN)) {
      throw redirect({ to: "/unauthorized" });
    }
  },
  component: DevPage,
  errorComponent: ErrorComponent,
});

function DevPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-8 p-8">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold">Entwickler-Tools</h1>
          <Badge variant="outline">{env.VITE_ENVIRONMENT}</Badge>
        </div>
        <p className="text-sm text-muted-foreground">
          Interne Werkzeuge zum Testen und Debuggen. Nur für Benutzer mit der Rolle{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 text-xs">eport-admin</code> sichtbar.
        </p>
      </div>

      <Separator />

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Sentry Error Logging</h2>
        <p className="text-sm text-muted-foreground">
          Alle Fehler werden mit dem Präfix <code className="rounded bg-muted px-1.5 py-0.5 text-xs">EPORT-DUMMY-EXCEPTION:</code> erzeugt und
          automatisch mit dem Tag <code className="rounded bg-muted px-1.5 py-0.5 text-xs">dummy:true</code> in Sentry markiert.
        </p>
      </section>

      <SentryFrontendTests />

      <Separator />

      <SentryBackendTests />
    </div>
  );
}

function ErrorComponent() {
  const router = useRouter();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-10">
      <p>Ein Fehler ist aufgetreten</p>
      <Button
        onClick={() => {
          void router.invalidate();
        }}
      >
        Erneut versuchen
      </Button>
    </div>
  );
}
